module.exports = __webpack_public_path__ + "img/pr-5.a3aee838.png";